var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Card',[_c('ui-treeview',{staticClass:"main-table",attrs:{"items":_vm.rows},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var item = ref.item;
return [_vm._v("\n        "+_vm._s(item.name)+"\n      ")]}}])})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }